import makeSlice from '@web/slices/error/sliceMaker'

const errorSlice = makeSlice({})

export default errorSlice.reducer
